window.addEventListener('show-update-status-confirmation', event => {
    showPrintSweetAlert(event.detail.day);
})

function showPrintSweetAlert(day) {
    Swal.fire({
        title: 'Wollen sie die Termine bekanntgeben?',
        showDenyButton: true,
        confirmButtonText: 'Ja',
        denyButtonText: `Nein`,
    }).then((result) => {
        if (result.isConfirmed) {
            Livewire.dispatch('updateDayStatus', {day: day})
            Swal.fire('Bekanntgegeben!', '', 'success')
        } else if (result.isDenied) {
            Swal.fire('Abgebrochen!', '', 'info')
        }
    })
}
